import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";

const blue = "#08306b";
const yellow = "#fffd33";


// Mock cocktails data - replace them with actual data from database
const sampleCocktails = {

};

function BarCocktailsPage() {
  const { barName } = useParams();
  const [language, setLanguage] = useState("en");
  const [cocktails, setCocktails] = useState([]);
  const navigate = useNavigate();
  const handleBack = () => {
    navigate("/manage-bars");
  };

  const handleDelete = async (id) => {
    const cocktail = cocktails.find((c) => c.id === id);
    if (!cocktail) return;

    if (window.confirm(`Delete cocktail "${cocktail.name[language]}"?`)) {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/cocktails/${id}`, {
          method: "DELETE",
        });

        if (!response.ok) throw new Error("Failed to delete");

        setCocktails(cocktails.filter((c) => c.id !== id));
        alert("Cocktail deleted successfully!");
      } catch (error) {
        console.error("❌ Delete error:", error);
        alert("Failed to delete cocktail.");
      }
    }
  };


    useEffect(() => {
      if (!barName) return;
      fetch(`${process.env.REACT_APP_API_URL}/cocktails/for-menu/${barName}`)
        .then((res) => res.json())
        .then(data => {
          console.log("📦 Received cocktails from API:", data); // ✅ Debug log
          setCocktails(data);
        })
        .catch((err) => console.error("Failed to load cocktails:", err));
    }, [barName]);
  

  return (
    <div style={styles.container}>
      {/* Back Button */}
      <button style={styles.back} onClick={handleBack}>←</button>

      <h1 style={styles.title}>{barName} – Cocktails</h1>
      <div style={styles.list}>
        {cocktails.map((cocktail) => (
          <div key={cocktail.id} style={styles.row}>
            <span>{cocktail.name[language]} </span>
            <div>
              <button
                style={styles.editBtn}
                // onClick={() => navigate(`/edit-cocktail/${cocktail.id}`)}
                onClick={() =>
                  navigate(`/edit-cocktail/${cocktail.id}`, { state: { cocktail } })
                }                
              >
                Edit
              </button>
              <button
                style={styles.deleteBtn}
                onClick={() => handleDelete(cocktail.id)}
              >
                ✕
              </button>
            </div>
          </div>
        ))}
        {cocktails.length === 0 && (
          <p style={{ marginTop: 20 }}>No cocktails found.</p>
        )}
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: "100vh",
    backgroundColor: blue,
    color: "#fff",
    padding: "40px 20px",
    fontFamily: "'Segoe UI', sans-serif",
  },
  title: {
    fontSize: "32px",
    marginBottom: "24px",
    textAlign: "center",
  },
  list: {
    maxWidth: "600px",
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  row: {
    backgroundColor: yellow,
    color: blue,
    padding: "12px 18px",
    borderRadius: "10px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontWeight: "bold",
  },
  editBtn: {
    backgroundColor: blue,
    color: yellow,
    border: "none",
    padding: "6px 12px",
    borderRadius: "6px",
    cursor: "pointer",
    marginRight: "10px",
  },
  deleteBtn: {
    backgroundColor: "transparent",
    border: "none",
    color: blue,
    fontSize: "20px",
    fontWeight: "bold",
    cursor: "pointer",
  },
  back: {
    alignSelf: "flex-start",
    fontSize: "24px",
    background: "none",
    border: "none",
    color: yellow,
    cursor: "pointer",
    marginBottom: "20px",
  },
};

export default BarCocktailsPage;